export default __webpack_public_path__ + "static/media/artist-img1.b7bd4089.jpg";